import { Button, MenuItem } from "@mui/material";

import { useSetup } from "../../Setup.context";

import { BenefitsPolicyVigencyType, IBenefitsPolicy, IBenefitsPolicyRegion, IBenefitsPolicyUnique } from "../../Setup.types";
import { ButtonDelete, Row, SelectForm, Title } from "./BenefitsPolicy.styled";

import { locationOptions } from "v2/pages/MissingDataFormulary/MissingDataMultistep/helper";

interface IProps {
  benefitsPolicy: IBenefitsPolicy;
  handleChange: (payload: Partial<IBenefitsPolicy>) => void;
}

export function BenefitsPolicyUnique({ benefitsPolicy, handleChange }: IProps) {
  const { setup } = useSetup();

  /** Opções possíveis da coluna de Plano. */
  const planOptions = setup.rules.rulesElegibility.plans.map(plan => plan.planName).filter(plan => !!plan);

  function handleUpdateUnique(payload: Partial<IBenefitsPolicyUnique>) {
    handleChange({ 
      ...benefitsPolicy, 
      benefitsPolicyByUnique: { 
        ...benefitsPolicy.benefitsPolicyByUnique, 
        ...payload 
      } 
    });
  }

  return (
    <>
      <Title>Plano único</Title>
      <Row style={{ alignItems: "center"}}>
        <SelectForm
          label="Plano"
          value={benefitsPolicy?.benefitsPolicyByUnique?.plan}
          onChange={(e) => handleUpdateUnique({ plan: e.target.value as string })}
        >
          {planOptions.map(option => (
            <MenuItem key={option} value={option}>{option}</MenuItem>
          ))}
        </SelectForm>
      </Row>
    </>
  );
}
